import {Box, Typography, Grid, Container, ImageListItem, ImageListItemBar, Fade} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {useEffect, useMemo, useRef, useState} from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router";
import {InlineWidget} from "react-calendly";
import ButtonBase from "@mui/material/ButtonBase";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const slides = [
    { src: "images/studio-i-slides/slide-1.jpg", alt: "Studio I - slide 1" },
    { src: "images/studio-i-slides/slide-2.jpg", alt: "Studio I - slide 2" },
    { src: "images/studio-i-slides/slide-3.jpg", alt: "Studio I - slide 3" },
    { src: "images/studio-i-slides/slide-4.jpg", alt: "Studio I - slide 4" },
    { src: "images/studio-i-slides/slide-5.jpg", alt: "Studio I - slide 5" },
    { src: "images/studio-i-slides/slide-6.jpg", alt: "Studio I - slide 6" },
    { src: "images/studio-i-slides/slide-7.jpg", alt: "Studio I - slide 7" },
    { src: "images/studio-i-slides/slide-8.jpg", alt: "Studio I - slide 8" },
    { src: "images/studio-i-slides/slide-9.jpg", alt: "Studio I - slide 9" },
];


function Book() {

    useEffect(() => {
        window?.lazyLoad();
    }, []);

    const navigate = useNavigate();

    const userData = localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData"))
        : {};

    console.log("userData", userData);

    const [step, setStep] = useState(0);
    const classes = useStyle({ step });
    const [canAgree, setCanAgree] = useState(false);
    const [agreed, setAgreed] = useState(false);

    const agreementRef = useRef(null);
    const [hasScrolledBottomOnce, setHasScrolledBottomOnce] = useState(false);

    const handleAgreementScroll = ()=> {
        const el = agreementRef.current;
        if (!el || hasScrolledBottomOnce) return;

        const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
        if (isAtBottom) {
            setHasScrolledBottomOnce(true);
            setCanAgree(true);
        }
    }

    const [isFullscreen, setIsFullscreen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);

    const calendlyUrl = useMemo(() => {
        if (!userData?._id) return "https://calendly.com/jamshid-studiodmi/30min";

        const fullName = userData?.name?.trim() || "";
        let firstName = fullName;
        let lastName = "";

        if (fullName.includes(" ")) {
            const parts = fullName.split(" ");
            firstName = parts[0];
            lastName = parts.slice(1).join(" ");
        }

        const url = new URL("https://calendly.com/jamshid-studiodmi/30min");
        url.searchParams.set("utm_source", userData._id);

        if (firstName) url.searchParams.set("first_name", firstName);
        if (lastName) url.searchParams.set("last_name", lastName);
        if (userData.email) url.searchParams.set("email", userData.email);

        return url.toString();
    }, [userData?._id, userData?.name, userData?.email]);

    return (
        <>
            <Helmet>
                <script
                    async
                    src="https://www.googletagmanager.com/gtag/js?id=UA-146650847-1"
                ></script>

                <title>Studio DMI | Book A Studio</title>
                <meta charset="UTF-8"/>
                <meta name="description" content=""/>
                <meta name="referrer" content="origin"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>

                <link
                    rel="icon"
                    type="image/png"
                    sizes="32x32"
                    href="images/favicon.png"
                />

                <link
                    type="text/css"
                    rel="stylesheet"
                    href="css/main.css?v=022621"
                    media="all"
                />
                {/*<script type="text/javascript" src="js/scrollreal.min.js"></script>*/}
            </Helmet>

            <div className={classes.container}>
                <div className={`section studio-single studio-single-left ${classes.section}`}>
                    <div
                        className={`bgr-style ${classes.bgImage}`}
                        style={{
                            backgroundImage: `
                                linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)),
                                url(images/bgr-slide-studio-i-new-low.jpg)
                            `,
                            filter: "blur(5px)",
                        }}
                    >
                    </div>
                    <div className={`container no-padding ${classes.content}`}>
                        <Box className={classes.backButton}>
                            <ButtonBase onClick={() => navigate(-1)}>
                                <ArrowBack />
                                &nbsp; Back
                            </ButtonBase>
                        </Box>

                        <div className={classes.widget}>
                            {step === 0 && (
                                <Box sx={{display: "flex", justifyContent: "center", lg: {
                                        mr: "167px"
                                    }}}>
                                    <Box sx={{maxWidth: 524}}>
                                        <Typography variant="h5" sx={{fontWeight:500, fontSize: "2rem", lg: {fontSize: "3rem"}, mb: "16px"}}>Before you book your studio</Typography>
                                        <Typography sx={{mb: "16px"}}>
                                            We just need you to review and sign a short lease agreement. It only takes a minute and helps us make sure your booking is fully protected and confirmed.
                                        </Typography>

                                        <ButtonBase
                                            sx={{mt: "20px", md: {mt: "4px"}, lg: {mt:0}}}
                                            className="btn-primary"
                                            onClick={() => setStep(1)}
                                            aria-label="Review and sign agreement"
                                        >
                                            Review &amp; Sign Agreement
                                        </ButtonBase>
                                    </Box>
                                </Box>

                            )}

                            {step === 1 && (
                                <>
                                <Box sx={{display: "flex", alignItems: "center", flexDirection: "column",
                                    mt: "-80px",
                                    "@media (min-width:667px)": {
                                        mt: 0,
                                    },
                                    lg: {
                                        mr: "167px"
                                    }}}>
                                    <Box sx={{ maxWidth: 524}}>
                                        <Box
                                            ref={agreementRef}
                                            onScroll={handleAgreementScroll}
                                            tabIndex={0}
                                            sx={{ maxHeight: 530, overflowY: "auto"}}
                                            aria-label="Lease agreement scrollable text"
                                        >
                                            <Typography>
                                                <Typography as="span" fontWeight={900}>Short-Term Studio Rental Agreement</Typography>
                                                <br/>
                                                This Short-Term Studio Rental Agreement (the “Agreement”) is entered into by and between European Music Market Inc. (“Landlord”) and the undersigned (“Renter”). Landlord agrees to rent the studio space located at 6839 Ponderosa Way, Studio I, Las Vegas, NV 89118 (the “Premises”) to Renter under the terms below.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}> 1. Term</Typography><br/>
                                                The rental term shall be for the specific hours and/or dates reserved and paid for by Renter. No tenancy or leasehold is created by this Agreement. This is a license for short-term use only.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>2. Payment</Typography><br/>
                                                Renter shall pay all rental fees in advance at the time of booking. Landlord reserves the right to require a security deposit at its discretion. Rental fees are non-refundable except as provided in Section 6 (Damage or Unavailability).
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>3. Use of Premises</Typography><br/>
                                                The Premises shall be used only for studio recording, production, rehearsals, or related creative purposes. Renter shall comply with all applicable laws, building rules, and Landlord’s instructions. No hazardous, unlawful, or disruptive activities are permitted.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>4. Repairs and Maintenance</Typography><br/>
                                                Landlord shall maintain the Premises and all building systems (including HVAC, electrical, plumbing, and roof) in good working condition. Renter shall be responsible only for damage caused by Renter, Renter’s guests, or contractors, beyond normal wear and tear.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>5. Landlord Provided Equipment</Typography><br/>
                                                Landlord shall provide equipment, fixtures, and furnishings as listed on the attached Inventory List (if any). Renter shall use such equipment responsibly and return all items in the same condition. Renter shall be responsible for repair or replacement costs if equipment is damaged due to misuse or negligence.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>6. Damage or Unavailability</Typography><br/>
                                                If the Premises become unusable during the rental period due to no fault of Renter, Landlord’s sole obligation shall be to refund rental fees for the unused portion of the rental period.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>7. Insurance & Indemnity</Typography><br/>
                                                Landlord shall maintain property and liability insurance for the Premises. Renter shall indemnify and hold harmless Landlord from any claims, damages, or liabilities arising from Renter’s use of the Premises, except to the extent caused by Landlord’s gross negligence or willful misconduct.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>8. Entry</Typography><br/>
                                                Landlord may enter the Premises at any time for emergencies or to ensure compliance with this Agreement. Otherwise, Landlord shall not unreasonably interfere with Renter’s use during the rental period.
                                                <br/>  <br/>
                                                <Typography as="span" fontWeight={900}>9. Miscellaneous</Typography><br/>
                                                a) This Agreement constitutes a license, not a lease. b) Renter may not assign or transfer this Agreement. c) Any disputes shall be governed by Nevada law and resolved in Clark County, Nevada. d) This Agreement is the entire agreement between the parties and may only be amended in writing signed by both parties.

                                            </Typography>
                                        </Box>

                                        <Box style={{ marginTop: 25 }}>
                                            <ButtonBase
                                                className="btn-primary"
                                                style={{
                                                    opacity: canAgree ? 1 : 0.5,
                                                    pointerEvents: canAgree ? "auto" : "none",
                                                    transition: "opacity 0.2s",
                                                }}
                                                onClick={() => {
                                                    setAgreed(true);
                                                    setStep(2);
                                                }}
                                                disabled={!canAgree}
                                                aria-disabled={!canAgree}
                                            >
                                                I agree &amp; sign
                                            </ButtonBase>
                                        </Box>
                                    </Box>
                                </Box>
                                </>
                            )}
                            {step === 2 && (
                                <InlineWidget styles={{
                                    height: "100%",
                                }}
                                url={calendlyUrl} />
                            )}
                        </div>

                        <div className={classes.studioContent}>
                            <div>
                                <Box className={classes.carouselWrapper}>
                                    <Carousel
                                        showThumbs={false}
                                        showStatus={false}
                                        infiniteLoop
                                        autoPlay={!isFullscreen}
                                        interval={5000}
                                        stopOnHover
                                        swipeable
                                        emulateTouch
                                        dynamicHeight={false}
                                        showArrows
                                        showIndicators
                                        useKeyboardArrows
                                        ariaLabel="Studio I image carousel"
                                        className={classes.carouselWrapper}
                                        selectedItem={currentSlide}
                                        onChange={(index) => setCurrentSlide(index)}
                                    >
                                        {slides.map((s, i) => (
                                            <div key={i} onClick={() => setIsFullscreen(true)}>
                                                <img
                                                    src={s.src}
                                                    alt={s.alt}
                                                    className={classes.studioImg}
                                                    style={{
                                                        display: "block",
                                                        margin: "0 auto",
                                                        objectFit: "cover",
                                                        cursor: "pointer",
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </Carousel>

                                    {isFullscreen && (
                                        <Box
                                            sx={{
                                                position: "fixed",
                                                top: 0,
                                                left: 0,
                                                width: "100vw",
                                                height: "100vh",
                                                backgroundColor: "rgba(0,0,0,0.95)",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                zIndex: 9999,
                                            }}
                                            onClick={() => setIsFullscreen(false)}
                                        >
                                            <Box
                                                sx={{marginTop: "90px" }}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                            <Carousel
                                                showThumbs={false}
                                                showStatus={false}
                                                infiniteLoop
                                                autoPlay={false}
                                                selectedItem={currentSlide}
                                                onChange={(index) => setCurrentSlide(index)}
                                                useKeyboardArrows
                                                swipeable
                                                emulateTouch
                                                dynamicHeight={false}
                                                showArrows
                                                showIndicators
                                                ariaLabel="Fullscreen Studio I image carousel"

                                            >
                                                {slides.map((s, i) => (
                                                    <div key={i}>
                                                        <img
                                                            src={s.src}
                                                            alt={s.alt}
                                                            style={{
                                                                maxHeight: "calc(100vh - 180px)",
                                                                objectFit: "contain",
                                                                width: "auto",
                                                                margin: "0 auto",
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </Carousel>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    position: "absolute",
                                                    top: 90,
                                                    right: 40,
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                    fontSize: "1rem",
                                                }}
                                                onClick={() => setIsFullscreen(false)}
                                            >
                                                ✕ Close
                                            </Typography>
                                        </Box>
                                        </Box>
                                    )}
                                </Box>
                            </div>
                            <div className="">

                                <div className={classes.studioContentText}>
                                    <h2>Studio I</h2>

                                    <p>
                                        A hybrid analog/digital mixing and mastering
                                        room equipped with a combination of vintage and
                                        modern gear, and plugins.
                                    </p>
                                </div>

                                    {/*<div className={classes.studioContentButton}>*/}
                                    {/*    <a*/}
                                    {/*        href="/#studio-services"*/}
                                    {/*        className="btn-primary"*/}
                                    {/*    >*/}
                                    {/*        Start your project*/}
                                    {/*    </a>*/}
                                    {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>

    );
}

const useStyle = makeStyles((theme) => ({
    "slick-slide": {
        outline: "none",
    },
    carouselWrapper: {
        overflow: "hidden",
        borderRadius: "10px"
    },
    header: {
        color: "#fff",
        fontSize: "28px",
        fontWeight: 700,
        marginBottom: theme.spacing(2),
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    },

    subtitle: {
        color: "rgba(255, 255, 255, 0.7)",
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: 1.5,
        marginBottom: theme.spacing(2),
    },
    bgImage: {
        position: "absolute",
        zIndex: "1",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        [theme.breakpoints.down("lg")]: {
            height: "400px",
            "&::after": {
                content: '""',
                position: "absolute",
                left: 0,
                bottom: 0,
                width: "100%",
                height: "80px",
                pointerEvents: "none",
                background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 80%, #000000 100%)",
            },
        },
    },
    container: {

        [theme.breakpoints.up("lg")]: {
            height: "100dvh",
            minHeight: "100dvh",
        },
        position: "relative",
        display: "flex",
    },
    content: {
        position: "relative",
        flexDirection: "row",
        [theme.breakpoints.down("lg")]: {
            flexDirection: "column",
        },
    },
    section: {
        height: "100%",
        width: "100%",
        background: "black",
        position: "relative",
    },
    widget:{
        flex:1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflow: "hidden",
        paddingTop: "80px",

        [theme.breakpoints.down("lg")]: {
            height: (props) =>
                props.step === 0
                    ? "500px"
                    : props.step === 1
                        ? "750px"
                        : "1100px",
            justifyContent: (props) =>
                props.step === 2
                    ? "center"
                    : "flex-start",
            padding: "80px 36px 0",
            paddingTop: (props) =>
                props.step === 2
                    ? "80px"
                    : "120px",
            flex: "unset"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "80px 12px 0",
        },
    },
    studioImg: {
      borderRadius: "10px",
        height: "261px",
        width: "100%"
    },
    studioContent: {
        width: "100%",
        maxWidth: "min(30%, 567px)",
        backgroundColor: "#0B0E10B2",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        padding: "0 35px",
        gap: "40px",
        [theme.breakpoints.down("lg")]: {
            margin: "0 auto",
            maxWidth: "554px",
            width: "100%",
            backgroundColor: "unset",
            padding: "30px 15px 135px",
        },
    },

    studioContentText: {
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        "& > *": {
            marginBottom: "0 !important",
        },
    },

    studioContentButton: {
        marginTop: "20px",
    },

    backButton: {
        margin: "0 3.5% 0 2%",
        height: "100%",
        paddingTop: "140px",
        display: "flex",
        [theme.breakpoints.down("lg")]: {
            display: "none",
        },

    },
}));

export default Book;

